import { render, staticRenderFns } from "./DialogEditPlayers.vue?vue&type=template&id=772a8645&"
import script from "./DialogEditPlayers.vue?vue&type=script&lang=ts&"
export * from "./DialogEditPlayers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports